// When a press outside a dialog closes it (design-system.md §3), as a pure function: the dialog owns the events.

interface ChangeDetails {
  reason: string;
  event: Event | { detail?: unknown };
}

/**
 * The second press of a double click that opened the dialog lands on its backdrop, which is mounted by the first
 * (a row of a grid opens on one click): it is not a press to close it. A double click that starts on the backdrop
 * still closes it with its first press.
 */
export function isSecondPressOfOpening({ reason, event }: ChangeDetails): boolean {
  return reason === "outside-press" && "detail" in event && typeof event.detail === "number" && event.detail > 1;
}
